(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    


function cart_spin()
{

$( ".custom-spinner" ).spinner({
min: 1
});

}

$(document)	
.on( 'shopify:section:select', cart_spin )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
function  prceload() {
$(function() {

    $('.minamount').val('0');
    $('.maxamount').val('0');
    var cursbl = String($("#product_collection .product_price").find(".price").find('.money').eq(0).text().replace(/-?[0-9]*\.?[0-9]+/, ""));
    var prices = [];
    $("#product_collection .product_price").each(function() {
      var price2 = parseInt($(this).data('price'), 10);
      prices.push(price2);
    });

    $("#product_collection .product_price").find(".price").each(function() {

      var number = Number($(this).find('.money').eq(0).text().replace(/[^0-9\.-]+/g, ""));
      var price2 = parseInt(number, 10);
      prices.push(price2);
      $(this).closest(".product_price").data('price', price2);


    });
    prices.sort(function(a, b) {
      return a - b
    });
    var low = Math.min.apply(Math, prices);

    var high = Math.max.apply(Math, prices);
    slider_updt(low, high, cursbl);
    $("#search-price").click(function() {

      var min = $('.minamount').data('prod_price_min'),
          max = $('.maxamount').data('prod_price_max');
      showProducts(min, max);

    });
  });
}
$(document)
 .on('shopify:section:load', prceload );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Homepage-banner"] && !window.DesignMode) return;
  try {
    
/* jquery for section load */
function ftrload() {
  $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 

        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {

        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }


      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
 
  }


$(document)
 .on( 'shopify:section:load', ftrload )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-collection"] && !window.DesignMode) return;
  try {
    
$(document)
 .on( 'shopify:section:load', minload )
;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product"] && !window.DesignMode) return;
  try {
    
/* jquery for section load */
function ftrload() {
  $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });

    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 

        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {

        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }


      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
 
  }


$(document)
 .on( 'shopify:section:load', ftrload )
;
/* ends */

  $(document).ready(function() {
    $('ul.choose').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      
     links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });
$( document ).ready(function() {
  (function($){
    function fixButtonHeights() {
      var heights = new Array();

      // Loop to get all element heights
      $('.home-prod-height').each(function() { 
        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        heights.push($(this).height());
      });

      // Find max height of all elements
      var max = Math.max.apply( Math, heights );

      // Set all heights to max height
      $('.home-prod-height').each(function() {
        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border

      }); 
    }

    $(window).load(function() {
      // Fix heights on page load
      fixButtonHeights();

      // Fix heights on window resize
      $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
          fixButtonHeights();
        }, 100);
      });
    });
  })(jQuery);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slider"] && !window.DesignMode) return;
  try {
    

function revload() {
  jQuery('.tp-banner').revolution(
			{
				delay:8000,
				startwidth:1170,
				startheight:860,
				hideThumbs:0,
				navigationStyle:'custom-bullets',
				navigationVAlign:'bottom',
				navigationHAlign:'right',
					
				soloArrowRightHalign:'right',
			    soloArrowRightValign:'bottom',
			    soloArrowRightHOffset:22,
			    soloArrowRightVOffset:120,
			
				soloArrowLeftHalign:'right',
			    soloArrowLeftValign:'bottom',
			    soloArrowLeftHOffset:22,
			    soloArrowLeftVOffset:120
			});
			//positioning the left (up) arrow on the slider
			var bottommargin = $('.tp-bullets').height() + 33 + 'px';
			$('.tp-leftarrow').css('margin-bottom', bottommargin);
			
			// Adding numbers to pages
			var rs_pages_count = $('.tp-banner li').length;
			$('#rs-pages').html('<span>' + rs_pages_count + '</span>');
				
			for (var i = 0; i < $('.tp-banner li').length; i++) {
				var slides = $('.tp-banner li #rs-current-page');
				var selector = slides[i];
				$(selector).html(i + 1);
			}
		

}
 
$(document)
 .on('shopify:section:load', revload )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

$(document)	
 .on( 'shopify:section:select', prod_tabload )
;

  } catch(e) { console.error(e); }
})();

})();
